"use client";

import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

export type TPortal = {
  children: React.ReactNode;
  selector?: Element | DocumentFragment;
};

export const Portal = ({ children, selector }: TPortal) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const container = selector || document.body;
  return ReactDOM.createPortal(children, container);
};
